import React from 'react';
import { t } from '../../i18n';

const VARIANT_CLASSES = {
  primary: 'bg-brand-600 text-white border border-brand-600 hover:bg-brand-700 disabled:bg-neutral-200 disabled:border-neutral-200 disabled:text-neutral-400',
  secondary: 'bg-white text-neutral-700 border border-neutral-300 hover:bg-neutral-50 disabled:text-neutral-300 disabled:bg-neutral-50',
  danger: 'bg-white text-danger-600 border border-danger-200 hover:bg-danger-50 disabled:text-neutral-300 disabled:border-neutral-200',
};

const Button = ({
  variant = 'secondary',
  size = 'md',
  icon: Icon = null,
  disabled = false,
  disabledReason = '',
  className = '',
  children,
  type = 'button',
  ...rest
}) => {
  const sizeClass = size === 'sm' ? 'h-7 px-2.5 text-xs' : 'h-8 px-3 text-sm';
  const variantClass = VARIANT_CLASSES[variant] || VARIANT_CLASSES.secondary;

  return (
    <button
      type={type}
      disabled={disabled}
      title={disabled ? t(disabledReason) : undefined}
      className={`inline-flex items-center justify-center gap-1.5 rounded font-medium transition-colors disabled:cursor-not-allowed focus:outline-none focus:ring-1 focus:ring-brand-400 focus:ring-offset-0 ${sizeClass} ${variantClass} ${className}`}
      {...rest}
    >
      {Icon && <Icon className="w-3.5 h-3.5" />}
      {children}
    </button>
  );
};

export default Button;
